import React, { useEffect, useState } from "react";
import { Spinner } from "./Spinner";
import { enviarVoto, getCandidatos, ObterURLArquivo } from "../services/cmsServices";
import { Dialog } from "@headlessui/react";
const seccionaisDetalhadas = [
  { nome: "AC/AM/RO/RR", cor: "#649970", estados: ["Acre", "Amazonas", "Rondônia", "Roraima"], delegados: [] },
  { nome: "AP/PA", cor: "#649970", estados: ["Amapá", "Pará"], delegados: [] },
  { nome: "MS/MT", cor: "#FFE099", estados: ["Mato Grosso", "Mato Grosso do Sul"], delegados: [] },
  { nome: "GO/TO", cor: "#FFE099", estados: ["Goiás", "Tocantins"], delegados: [] },
  { nome: "DF", cor: "#000000", estados: ["Distrito Federal"], delegados: [] },
  { nome: "SP", cor: "#ef9456", estados: ["São Paulo"], delegados: [] },
  { nome: "RJ", cor: "#ef9456", estados: ["Rio de Janeiro"], delegados: [] },
  { nome: "MG/ES", cor: "#ef9456", estados: ["Minas Gerais", "Espírito Santo"], delegados: [] },
  { nome: "SC", cor: "#5e2b1f", estados: ["Santa Catarina"], delegados: [] },
  { nome: "RS", cor: "#5e2b1f", estados: ["Rio Grande do Sul"], delegados: [] },
  { nome: "PR", cor: "#5e2b1f", estados: ["Paraná"], delegados: [] },
  { nome: "BA", cor: "#21606e", estados: ["Bahia"], delegados: [] },
  { nome: "AL/SE", cor: "#21606e", estados: ["Alagoas", "Sergipe"], delegados: [] },
  { nome: "CE", cor: "#21606e", estados: ["Ceará"], delegados: [] },
  { nome: "MA/PI", cor: "#21606e", estados: ["Maranhão", "Piauí"], delegados: [] },
  { nome: "PB/RN", cor: "#21606e", estados: ["Paraíba", "Rio Grande do Norte"], delegados: [] },
  { nome: "PE", cor: "#21606e", estados: ["Pernambuco"], delegados: [] }
];

const slugify = (text) =>
  text.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-');

const MapaSeccionais = () => {

  const verificarHorarioExato = () => {
    const agora = new Date();
    const agoraEmSP = new Date(agora.toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }));
    const dataLimite = new Date('2025-09-12T17:00:00');

    // Mostra até chegar exatamente às 17:00 do dia 12-09-2025
    return agoraEmSP < dataLimite;
  };

  const cardAtivo = verificarHorarioExato();


  const [filtro, setFiltro] = useState("");
  const [sugestoes, setSugestoes] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [imagemCarregando, setImagemCarregando] = useState(true);
  const [videoCarregando, setVideoCarregando] = useState(true);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.gstatic.com/charts/loader.js";
    script.onload = () => {
      window.google.charts.load("current", { packages: ["geochart"], mapsApiKey: "YOUR_GOOGLE_API_KEY" });
      window.google.charts.setOnLoadCallback(drawRegionsMap);
    };
    document.body.appendChild(script);
  }, []);

  const drawRegionsMap = () => {
    const estadoSeccionalData = [["State", "Seccional", { role: "tooltip", type: "string", p: { html: true } }]];
    let corIndex = 1;
    seccionaisDetalhadas.forEach((sec) => {
      sec.estados.forEach((estado) => {
        const tooltipText = `        
          Estados: ${sec.nome}       
      `;
        estadoSeccionalData.push([estado, corIndex, tooltipText]);
      });
      corIndex++;
    });

    const data = window.google.visualization.arrayToDataTable(estadoSeccionalData);

    const options = {
      region: 'BR',
      resolution: 'provinces',
      displayMode: 'regions',
      datalessRegionColor: '',
      backgroundColor: '',
      colorAxis: {
        values: seccionaisDetalhadas.map((_, index) => index + 1),
        colors: seccionaisDetalhadas.map(sec => sec.cor)
      },
      legend: 'none',
    };

    const chart = new window.google.visualization.GeoChart(document.getElementById("regions_div"));
    chart.draw(data, options);

    window.google.visualization.events.addListener(chart, 'regionClick', function (event) {
      const estadoClicado = event.region; // exemplo: "BR-DF"
      const nomeEstado = getNomeEstadoPorSigla(estadoClicado.split("-")[1]);

      const seccionalEncontrada = seccionaisDetalhadas.find(sec =>
        sec.estados.some(e => normalizar(e) === normalizar(nomeEstado))
      );
      console.log(seccionalEncontrada);

      if (seccionalEncontrada) {
        setModalData({ label: seccionalEncontrada.nome, type: "seccional", seccional: seccionalEncontrada });
        setModalOpen(true);
      }
    });


  };

  const filtrarSeccionais = (seccionais, termo) => {
    if (!termo) return seccionais;
    const termoLower = termo.toLowerCase();
    return seccionais.filter(sec =>
      sec.estados.some(est => est.toLowerCase().includes(termoLower)) ||
      sec.delegados.some(del => del.nome.toLowerCase().includes(termoLower)) || // 👈 aqui
      sec.nome.toLowerCase().includes(termoLower)
    );
  };

  const getSugestoes = (termo) => {
    if (!termo) return [];

    const termoLower = termo.toLowerCase();
    const sugestoesSet = [];
    console.log(seccionaisDetalhadas);

    seccionaisDetalhadas.forEach(sec => {
      sec.estados.forEach(est => {
        if (est.toLowerCase().includes(termoLower)) sugestoesSet.push({ label: est, type: "estado", seccional: sec });
      });
      sec.delegados.forEach(del => {
        if (del.nome.toLowerCase().includes(termoLower)) {
          sugestoesSet.push({ label: del.nome, type: "delegado", seccional: sec, id: del.id }); // 👈 adiciona o id aqui também
        }
      });
      if (sec.nome.toLowerCase().includes(termoLower)) sugestoesSet.push({ label: sec.nome, type: "seccional", seccional: sec });
    });

    return sugestoesSet.slice(0, 10);
  };

  useEffect(() => {
    setSugestoes(getSugestoes(filtro));
  }, [filtro]);

  const handleSugestaoClick = (sug) => {
    setModalData(sug);
    setModalOpen(true);
  };
  const normalizar = (texto) =>
    texto.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '');

  const getNomeEstadoPorSigla = (sigla) => {
    const mapa = {
      "AC": "Acre", "AL": "Alagoas", "AP": "Amapa", "AM": "Amazonas", "BA": "Bahia",
      "CE": "Ceara", "DF": "Distrito Federal", "ES": "Espirito Santo", "GO": "Goias",
      "MA": "Maranhao", "MT": "Mato Grosso", "MS": "Mato Grosso do Sul", "MG": "Minas Gerais",
      "PA": "Para", "PB": "Paraiba", "PR": "Parana", "PE": "Pernambuco", "PI": "Piaui",
      "RJ": "Rio de Janeiro", "RN": "Rio Grande do Norte", "RS": "Rio Grande do Sul",
      "RO": "Rondonia", "RR": "Roraima", "SC": "Santa Catarina", "SP": "Sao Paulo",
      "SE": "Sergipe", "TO": "Tocantins"
    };
    return mapa[sigla] || "";
  };

  const renderModalContent = () => {
    if (!modalData) return null; // 👉 Primeiro valida

    const sec = modalData.seccional;
    const candidato = candidatos.find(c => c.idCandidato === modalData.id);

    if (modalData.type === "delegado") {
      return (
        <>
          <div className="text-center">
            <div className="flex items-center space-x-4 text-left mb-4">

              {candidato?.imagemCampanha && (
                <div className="relative w-24 h-24">
                  <>
                    {imagemCarregando && (
                      <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-full">
                        <div className="w-6 h-6 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin" />
                      </div>
                    )}
                    <img
                      src={ObterURLArquivo(candidato.imagemCampanha)}
                      alt={modalData.label}
                      onLoad={() => setImagemCarregando(false)}
                      className="w-24 h-24 rounded-full object-cover"
                      style={{ display: imagemCarregando ? "none" : "block" }}
                    />
                  </>
                </div>
              )}

              <div>
                <h2 className="text-sm font-bold lg:text-sm">{modalData.label}</h2>
                <p className="text-gray-600 text-[12px]">Número: {candidato.inscricao}</p>
                <p className="text-gray-600 text-[12px]">Nome Social: {candidato.nomeSocial}</p>
                <p className="text-gray-600 text-[12px]">
                  Associado desde: {
                    new Date(candidato.dtAssociado).toLocaleDateString('pt-BR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric'
                    })
                  }
                </p>
                <p className="text-gray-600 text-[12px]">Seccional: {sec.nome}</p>


              </div>
            </div>


            {candidato?.videoCampanha && (
              <div className="relative w-full h-64 mb-4">
                <>
                  {videoCarregando && (
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                      <div className="w-6 h-6 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin" />
                    </div>
                  )}
                  <video
                    className="w-full h-64"
                    controls
                    onLoadStart={() => setVideoCarregando(false)}
                    style={{ display: videoCarregando ? "none" : "block" }}
                  >
                    <source src={ObterURLArquivo(candidato.videoCampanha)} type="video/mp4" />
                    Seu navegador não suporta o elemento de vídeo.
                  </video>
                </>
              </div>
            )}


            <div className="text-left space-y-2">
              {candidato?.cartaCampanha ? (
                candidato.cartaCampanha.split("\n").map((par, i) => (
                  <p key={i}>{par}</p>
                ))
              ) : (
                <p className="italic text-gray-500"></p>
              )}
            </div>
          </div>

          <div id="modal_map" className="w-full h-80 mt-4"></div>
        </>
      );
    } else {
      return (
        <>
          <h2 className="text-2xl font-bold">{sec.nome}</h2>
          <p className="text-gray-600">Estados: {sec.estados.join(", ")}</p>
          {/* <p className="mt-2 font-semibold">Candidatos:</p>*/}
          <ul className="space-y-1">
            {sec.delegados
              .sort((a, b) => a.nome.localeCompare(b.nome))
              .map((d, i) => (

                <li
                  key={i}
                  className="group flex items-center gap-4 p-4 rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-200 cursor-pointer bg-white hover:bg-blue-50"
                  onClick={() => {
                    setModalData({
                      label: d.nome,
                      id: d.id,
                      type: "delegado",
                      seccional: sec
                    });
                  }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setModalData({
                        label: d.nome,
                        id: d.id,
                        type: "delegado",
                        seccional: sec
                      });
                    }
                  }}
                  aria-label={`Ver detalhes de ${d.nome}`}
                >
                  {/* Área da Imagem */}
                  <div className="flex-shrink-0">
                    {d?.thumb ? (
                      <div className="relative w-16 h-16 md:w-20 md:h-20">
                        {imagemCarregando && (
                          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-full border-2 border-gray-200">
                            <div className="w-6 h-6 border-3 border-gray-300 border-t-blue-500 rounded-full animate-spin" />
                          </div>
                        )}

                        <img
                          src={ObterURLArquivo(d.thumb)}
                          alt={`Foto de ${d.nome}`}
                          onLoad={() => setImagemCarregando(false)}
                          onError={() => setImagemCarregando(false)}
                          className={`w-16 h-16 md:w-20 md:h-20 rounded-full object-cover border-2 border-gray-200 group-hover:border-blue-300 transition-colors duration-200 ${imagemCarregando ? 'opacity-0' : 'opacity-100'
                            }`}
                        />
                      </div>
                    ) : (
                      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gray-200 flex items-center justify-center border-2 border-gray-300">
                        <svg
                          className="w-8 h-8 text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                        >
                          <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                        </svg>
                      </div>
                    )}
                  </div>

                  {d.nome}
                </li>
              ))}
          </ul>
          <div id="modal_map" className="w-full h-80 mt-4 "></div>
        </>
      );
    }
  };

  useEffect(() => {
    if (modalOpen && modalData) {
      setTimeout(() => {
        const todosEstados = [
          "Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará", "Distrito Federal", "Espírito Santo",
          "Goiás", "Maranhão", "Mato Grosso", "Mato Grosso do Sul", "Minas Gerais", "Pará", "Paraíba", "Paraná",
          "Pernambuco", "Piauí", "Rio de Janeiro", "Rio Grande do Norte", "Rio Grande do Sul",
          "Rondônia", "Roraima", "Santa Catarina", "São Paulo", "Sergipe", "Tocantins"
        ];

        console.log(modalData);

        const estadosSeccional = modalData.seccional.estados;

        const estadoSeccionalData = [["State", "Seccional"]];
        todosEstados.forEach((estado) => {
          const valor = estadosSeccional.includes(estado) ? 1 : 0;
          estadoSeccionalData.push([estado, valor]);
        });

        const data = window.google.visualization.arrayToDataTable(estadoSeccionalData);

        const options = {
          region: 'BR',
          resolution: 'provinces',
          displayMode: 'regions',
          backgroundColor: '#ffffff',
          datalessRegionColor: '#ffffff',
          colorAxis: {
            values: [0, 1],
            colors: ['#E5E7EB', modalData.seccional.cor] // cinza claro + cor da seccional
          },
          legend: 'none'
        };

        const chart = new window.google.visualization.GeoChart(document.getElementById("modal_map"));
        chart.draw(data, options);

        setTimeout(() => {
          const paths = document.querySelectorAll('#modal_map svg path');

          paths.forEach(path => {
            path.setAttribute('stroke', '#ffffff');
            path.setAttribute('stroke-width', '0.5');
            path.style.pointerEvents = 'none'; // desativa hover/click no path
          });

          // também desativa tooltips e qualquer highlight de área
          const rects = document.querySelectorAll('#modal_map svg rect');
          rects.forEach(rect => {
            rect.style.pointerEvents = 'none';
          });
        }, 50);
      }, 150);
    }
  }, [modalOpen, modalData]);

  const [candidatos, setCandidatos] = useState([]);

  useEffect(() => {
    getCandidatos(1).then((data) => {
      setCandidatos(data);

      // Agrupar os nomes por seccional
      const agrupados = {};

      data.forEach((cand) => {
        if (!agrupados[cand.seccional]) agrupados[cand.seccional] = [];
        agrupados[cand.seccional].push({
          nome: cand.nome,
          thumb: cand?.imagemCampanha,
          id: cand.idCandidato
        });
      });


      // Atualizar delegados em seccionaisDetalhadas
      seccionaisDetalhadas.forEach((sec) => {
        sec.delegados = agrupados[sec.nome] || [];
      });
    });
  }, []);

  useEffect(() => {
    if (modalOpen) {
      setImagemCarregando(true);
      setVideoCarregando(true);
    }
  }, [modalOpen]);


  if (!cardAtivo) {

    return (
      <section className="     mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-5xl font-bold">Conheça os candidatos</h2>
        </div>

        <div className="grid md:grid-cols-12 gap-5">
          <div className="md:col-span-8 p-0 m-0">
            <div id="regions_div" className="p-0 m-0"></div>
          </div>
          <div className="md:col-span-4 p-0 m-0">
            <div className="mb-6 relative p-0 m-0  ">
              <input
                type="text"
                placeholder="Filtrar por estado, seccional ou candidato..."
                className="border px-4 py-2 w-full rounded "
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
              {sugestoes.length > 0 && (
                <ul className="bg-white border rounded w-full max-h-60 overflow-y-auto z-10 shadow">
                  {sugestoes
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map((sug, index) => (
                      <li
                        key={index}
                        onClick={() => handleSugestaoClick(sug)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleSugestaoClick(sug);
                          }
                        }}
                        className="group flex items-center justify-between px-4 py-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-all duration-200 focus:outline-none focus:bg-blue-50 focus:ring-2 focus:ring-blue-200 focus:ring-inset"
                        tabIndex={0}
                        role="option"
                        aria-label={`Selecionar ${sug.label} - ${sug.type}`}
                      >
                        {/* Área principal do conteúdo */}
                        <div className="flex items-center gap-3 min-w-0 flex-1">
                          {/* Ícone baseado no tipo */}
                          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-100 group-hover:bg-blue-100 flex items-center justify-center transition-colors duration-200">
                            {sug.type === 'delegado' && (
                              <svg className="w-4 h-4 text-gray-600 group-hover:text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                              </svg>
                            )}

                            {sug.type === 'estado' && (
                              <svg className="w-4 h-4 text-gray-600 group-hover:text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                              </svg>
                            )}
                            {sug.type === 'seccional' && (
                              <svg className="w-4 h-4 text-gray-600 group-hover:text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                              </svg>
                            )}
                            {!['delegado', 'partido', 'estado', 'seccional'].includes(sug.type) && (
                              <svg className="w-4 h-4 text-gray-600 group-hover:text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                              </svg>
                            )}
                          </div>

                          {/* Conteúdo principal */}
                          <div className="min-w-0 flex-1">
                            <div className="flex items-baseline gap-2">
                              <span className="font-medium text-gray-900 group-hover:text-blue-700 transition-colors duration-200 truncate">
                                {sug.label}
                              </span>
                            </div>

                            {/* Informações adicionais se disponíveis */}
                            {sug.info && (
                              <p className="text-sm text-gray-500 mt-1 truncate">
                                {sug.info}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Área lateral direita */}
                        <div className="flex items-center gap-2 flex-shrink-0 ml-3">
                          {/* Badge do tipo */}
                          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium transition-colors duration-200 ${sug.type === 'delegado' ? 'bg-blue-100 text-blue-800 group-hover:bg-blue-200' :
                            sug.type === 'partido' ? 'bg-green-100 text-green-800 group-hover:bg-green-200' :
                              sug.type === 'estado' ? 'bg-purple-100 text-purple-800 group-hover:bg-purple-200' :
                                sug.type === 'seccional' ? 'bg-orange-100 text-orange-800 group-hover:bg-orange-200' :
                                  'bg-gray-100 text-gray-600 group-hover:bg-gray-200'
                            }`}>
                            {sug.type === 'delegado' ? '  Candidato' :
                              sug.type === 'partido' ? '  Partido' :
                                sug.type === 'estado' ? '  Estado' :
                                  sug.type === 'seccional' ? '  Seccional' :
                                    sug.type}
                          </span>

                          {/* Seta indicativa */}
                          <svg
                            className="w-4 h-4 text-gray-400 group-hover:text-blue-500 transition-colors duration-200"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </li>
                    ))}
                </ul>
              )}
            </div>
            <div className="flex flex-col space-y-4 lg:h-[600px] xl:h-[600px]  md:h-[600px] overflow-y-auto pr-2 ">
              {filtrarSeccionais(seccionaisDetalhadas, filtro).map((sec, index) => (
                <div
                  key={index}
                  className="border bg-white p-4 rounded shadow hover:shadow-md cursor-pointer "
                  onClick={() => {
                    setModalData({ label: sec.nome, type: "seccional", seccional: sec });
                    setModalOpen(true);
                  }}
                >
                  <h3 className="font-bold text-lg text-gray-800">{sec.nome}</h3>
                  <p className="text-sm text-gray-600">Estados: {sec.estados.join(", ")}</p>
                  {/* <p className="text-sm text-gray-600">Candidatos: {sec.delegados.length}</p>
                <span className="text-blue-600 mt-2 inline-block underline">Ver candidatos</span> */}
                </div>
              ))}
            </div>
          </div>
        </div>

        <Dialog open={modalOpen} onClose={() => setModalOpen(false)} className="fixed z-50 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen p-4 bg-black bg-opacity-50">
            <Dialog.Panel className="bg-white rounded p-6 w-full max-w-2xl">
              {renderModalContent()}
              <div className="mt-4 text-right">
                <button className="px-4 py-2 bg-gray-800 text-white rounded" onClick={() => setModalOpen(false)}>Fechar</button>                
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
      </section>
    );
  } else {

    return <></>;

  }
};

export default MapaSeccionais;